import { DropdownMenu } from '@nexelem/components';
import { NodeMultiplePopperNode } from './NodeMultiplePopperNode';
import { NodeType, QueueNode } from '../../types';
import { useCustomTranslation } from '../../../../../../hooks';
import { NodeBreakPopperNode } from './NodeBreakPopperNode';

type MultipleNodeDropdownMenuContentProps = {
  taskNodes: QueueNode[];
};

export const MultipleNodeDropdownMenuContent = ({ taskNodes }: MultipleNodeDropdownMenuContentProps) => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.settingDrawer');
  return (
    <DropdownMenu.Content className="z-999999">
      <>
        <div className="border-b border-border-secondary pt-4 pb-1 pl-4 text-s11-sb text-text-secondary uppercase">
          {tWrapper('tasks')} {`(${taskNodes.length})`}
        </div>
        <div className="max-h-80 overflow-auto">
          {taskNodes.map((node) => {
            if (node.type === NodeType.TASK) {
              const key = `${node.id}-${node.taskExecutionId}`;
              return <NodeMultiplePopperNode key={key} node={node} />;
            } else if (node.type === NodeType.BATCH) {
              return node.tasks?.map((task) => <NodeMultiplePopperNode batchNode={node} key={task.id} node={task} />);
            } else {
              return <NodeBreakPopperNode key={node.id} node={node} />;
            }
          })}
        </div>
      </>
    </DropdownMenu.Content>
  );
};
